import React, { useState } from 'react';

const STATUS_COLORS = {
    'Recibido': '#95a5a6',
    'Revisado': '#3498db',
    'Asignado': '#f39c12',
    'En proceso': '#e67e22',
    'Resuelto': '#27ae60',
    'Cerrado': '#7f8c8d'
};

const CATEGORY_LABELS = {
    iluminacion: 'Iluminacion',
    bancos: 'Bancos / Mobiliario',
    basura: 'Basura / Limpieza',
    vegetacion: 'Vegetacion / Poda',
    infraestructura: 'Infraestructura',
    otro: 'Otro'
};

const ASSIGNMENT_STATUS_COLORS = {
    'Pendiente': '#95a5a6',
    'En proceso': '#f39c12',
    'Completado': '#27ae60'
};

const VALID_TRANSITIONS = {
    'Recibido': ['Revisado', 'Cerrado'],
    'Revisado': ['Asignado', 'Cerrado'],
    'Asignado': ['En proceso', 'Cerrado'],
    'En proceso': ['Resuelto', 'Cerrado'],
    'Resuelto': ['Cerrado'],
    'Cerrado': []
};

const ReporteDetailModal = ({ reporte, brigades, onClose, onStatusChange, onAddAssignment, onRemoveAssignment, onUpdateAssignmentStatus, onAddComment, onExportPDF, onDelete }) => {
    const [newStatus, setNewStatus] = useState('');
    const [comment, setComment] = useState('');
    const [priority, setPriority] = useState(reporte.priority || 'media');
    const [newComment, setNewComment] = useState('');

    // Multi-brigada
    const [assignBrigadeId, setAssignBrigadeId] = useState('');
    const [assignCategories, setAssignCategories] = useState([]);
    const [assignDate, setAssignDate] = useState('');
    const [assignPriority, setAssignPriority] = useState('media');
    const [assignNotes, setAssignNotes] = useState('');

    const allowedTransitions = VALID_TRANSITIONS[reporte.status] || [];

    // Categorias que ya tienen brigada asignada
    const assignedCategories = (reporte.assignments || []).flatMap(a => a.categories || []);
    const unassignedCategories = (reporte.categories || []).filter(c => !assignedCategories.includes(c));

    const handleStatusSubmit = () => {
        if (!newStatus) return;
        const extra = { comment, priority };
        onStatusChange(reporte._id, newStatus, extra);
        setNewStatus('');
        setComment('');
    };

    const handleCommentSubmit = () => {
        if (!newComment.trim()) return;
        onAddComment(reporte._id, newComment.trim());
        setNewComment('');
    };

    const handleAddAssignment = () => {
        if (!assignBrigadeId || assignCategories.length === 0) return;
        onAddAssignment(reporte._id, {
            brigade: assignBrigadeId,
            categories: assignCategories,
            assignedDate: assignDate || null,
            priority: assignPriority,
            notes: assignNotes
        });
        setAssignBrigadeId('');
        setAssignCategories([]);
        setAssignDate('');
        setAssignPriority('media');
        setAssignNotes('');
    };

    const toggleAssignCategory = (cat) => {
        setAssignCategories(prev =>
            prev.includes(cat) ? prev.filter(c => c !== cat) : [...prev, cat]
        );
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="reporte-detail-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header-detail">
                    <div>
                        <h2>Reporte {reporte.trackingCode}</h2>
                        <span className="status-pill-admin" style={{
                            background: STATUS_COLORS[reporte.status], color: 'white'
                        }}>
                            {reporte.status}
                        </span>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        {onExportPDF && (
                            <button
                                className="btn-export-rc pdf"
                                onClick={() => onExportPDF(reporte)}
                                title="Exportar PDF"
                                style={{ padding: '5px 10px', fontSize: '0.75rem' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                                </svg>
                                PDF
                            </button>
                        )}
                        {onDelete && (
                            <button
                                className="btn-delete-reporte"
                                onClick={() => onDelete(reporte._id)}
                                title="Eliminar reporte"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                                </svg>
                            </button>
                        )}
                        <button className="modal-close-btn" onClick={onClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="modal-body-detail">
                    {/* Info */}
                    <div className="detail-section">
                        <h3>Informacion del Reporte</h3>
                        <div className="detail-grid">
                            <div className="detail-item">
                                <label>Reportante</label>
                                <span>{reporte.reporterName}</span>
                            </div>
                            <div className="detail-item">
                                <label>Contacto</label>
                                <span>{reporte.reporterContact} ({reporte.contactType === 'phone' ? 'Tel' : 'Email'})</span>
                            </div>
                            <div className="detail-item">
                                <label>Categorias</label>
                                <div className="detail-categories">
                                    {(reporte.categories || []).map(c => (
                                        <span key={c} className="cat-tag-sm">{CATEGORY_LABELS[c] || c}</span>
                                    ))}
                                </div>
                            </div>
                            <div className="detail-item">
                                <label>Ubicacion</label>
                                <span>{reporte.locationName || reporte.sector?.name || 'No especificado'}</span>
                            </div>
                            <div className="detail-item">
                                <label>Fecha Creacion</label>
                                <span>{new Date(reporte.createdAt).toLocaleString('es-ES')}</span>
                            </div>
                            <div className="detail-item">
                                <label>Prioridad</label>
                                <span style={{ textTransform: 'capitalize', fontWeight: 600 }}>{reporte.priority}</span>
                            </div>
                        </div>
                        <div className="detail-description">
                            <label>Descripcion</label>
                            <p>{reporte.description}</p>
                        </div>

                        {/* Imagenes del reporte */}
                        {reporte.images && reporte.images.length > 0 && (
                            <div className="detail-images">
                                <label>Fotos adjuntas ({reporte.images.length})</label>
                                <div className="detail-images-grid">
                                    {reporte.images.map((img, i) => (
                                        <a
                                            key={img.fileId || i}
                                            href={img.directLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="detail-image-item"
                                        >
                                            <img
                                                src={img.thumbnailLink || img.directLink}
                                                alt={img.originalName || `Foto ${i + 1}`}
                                                loading="lazy"
                                            />
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Asignaciones de brigadas (multi-brigada) */}
                    <div className="detail-section">
                        <h3>Brigadas Asignadas ({(reporte.assignments || []).length})</h3>

                        {(reporte.assignments || []).length > 0 ? (
                            <div className="assignments-list">
                                {(reporte.assignments || []).map((a) => (
                                    <div key={a._id} className="assignment-card">
                                        <div className="assignment-header">
                                            <div className="assignment-info">
                                                <strong>{a.brigade?.name || 'Brigada'}</strong>
                                                <span className="assignment-status-pill" style={{
                                                    background: ASSIGNMENT_STATUS_COLORS[a.status],
                                                    color: 'white'
                                                }}>
                                                    {a.status}
                                                </span>
                                            </div>
                                            <div className="assignment-actions-btns">
                                                {a.status !== 'Completado' && (
                                                    <select
                                                        className="assignment-status-select"
                                                        value={a.status}
                                                        onChange={(e) => onUpdateAssignmentStatus(reporte._id, a._id, e.target.value)}
                                                    >
                                                        <option value="Pendiente">Pendiente</option>
                                                        <option value="En proceso">En proceso</option>
                                                        <option value="Completado">Completado</option>
                                                    </select>
                                                )}
                                                <button
                                                    className="btn-remove-assignment"
                                                    onClick={() => onRemoveAssignment(reporte._id, a._id)}
                                                    title="Eliminar asignacion"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="assignment-categories">
                                            {(a.categories || []).map(c => (
                                                <span key={c} className="cat-tag-sm">{CATEGORY_LABELS[c] || c}</span>
                                            ))}
                                        </div>
                                        <div className="assignment-meta">
                                            {a.assignedDate && (
                                                <span>Fecha: {new Date(a.assignedDate).toLocaleDateString('es-ES')}</span>
                                            )}
                                            {a.priority && (
                                                <span>Prioridad: {a.priority}</span>
                                            )}
                                            {a.notes && (
                                                <span>Nota: {a.notes}</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="no-comments">Sin brigadas asignadas</p>
                        )}

                        {/* Agregar nueva asignacion */}
                        {unassignedCategories.length > 0 && (
                            <div className="add-assignment-section">
                                <h4>Agregar Brigada</h4>
                                <div className="add-assignment-form">
                                    <div className="assign-field">
                                        <label>Categorias a asignar:</label>
                                        <div className="assign-cat-grid">
                                            {unassignedCategories.map(cat => (
                                                <button
                                                    key={cat}
                                                    type="button"
                                                    className={`assign-cat-btn ${assignCategories.includes(cat) ? 'active' : ''}`}
                                                    onClick={() => toggleAssignCategory(cat)}
                                                >
                                                    {assignCategories.includes(cat) && <span className="check-mark">&#10003; </span>}
                                                    {CATEGORY_LABELS[cat] || cat}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="assign-row">
                                        <select value={assignBrigadeId} onChange={e => setAssignBrigadeId(e.target.value)}>
                                            <option value="">Seleccionar brigada...</option>
                                            {brigades.map(b => (
                                                <option key={b._id} value={b._id}>{b.name}</option>
                                            ))}
                                        </select>
                                        <select value={assignPriority} onChange={e => setAssignPriority(e.target.value)}>
                                            <option value="baja">Baja</option>
                                            <option value="media">Media</option>
                                            <option value="alta">Alta</option>
                                        </select>
                                        <input
                                            type="date"
                                            value={assignDate}
                                            onChange={e => setAssignDate(e.target.value)}
                                        />
                                    </div>
                                    <input
                                        type="text"
                                        className="assign-notes-input"
                                        placeholder="Notas (opcional)"
                                        value={assignNotes}
                                        onChange={e => setAssignNotes(e.target.value)}
                                    />
                                    <button
                                        className="btn-assign-brigade"
                                        disabled={!assignBrigadeId || assignCategories.length === 0}
                                        onClick={handleAddAssignment}
                                    >
                                        Asignar Brigada
                                    </button>
                                </div>
                            </div>
                        )}

                        {unassignedCategories.length === 0 && (reporte.assignments || []).length > 0 && (
                            <p className="all-assigned-msg">Todas las categorias tienen brigada asignada</p>
                        )}
                    </div>

                    {/* Cambiar estado */}
                    {allowedTransitions.length > 0 && (
                        <div className="detail-section">
                            <h3>Cambiar Estado</h3>
                            <div className="status-change-form">
                                <div className="status-change-row">
                                    <select value={newStatus} onChange={e => setNewStatus(e.target.value)}>
                                        <option value="">Seleccionar estado...</option>
                                        {allowedTransitions.map(s => (
                                            <option key={s} value={s}>{s}</option>
                                        ))}
                                    </select>
                                    <select value={priority} onChange={e => setPriority(e.target.value)}>
                                        <option value="baja">Prioridad Baja</option>
                                        <option value="media">Prioridad Media</option>
                                        <option value="alta">Prioridad Alta</option>
                                    </select>
                                </div>
                                <textarea
                                    value={comment}
                                    onChange={e => setComment(e.target.value)}
                                    placeholder="Comentario sobre el cambio (opcional)"
                                    rows="2"
                                />
                                <button className="btn-change-status" onClick={handleStatusSubmit} disabled={!newStatus}>
                                    Cambiar Estado
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Comentarios */}
                    <div className="detail-section">
                        <h3>Comentarios Internos ({reporte.adminComments?.length || 0})</h3>
                        <div className="comments-list">
                            {(reporte.adminComments || []).map((c, idx) => (
                                <div key={idx} className="comment-item">
                                    <div className="comment-header">
                                        <strong>{c.author?.username || 'Admin'}</strong>
                                        <span>{new Date(c.createdAt).toLocaleString('es-ES')}</span>
                                    </div>
                                    <p>{c.text}</p>
                                </div>
                            ))}
                            {(!reporte.adminComments || reporte.adminComments.length === 0) && (
                                <p className="no-comments">Sin comentarios aun</p>
                            )}
                        </div>
                        <div className="add-comment">
                            <textarea
                                value={newComment}
                                onChange={e => setNewComment(e.target.value)}
                                placeholder="Agregar comentario interno..."
                                rows="2"
                            />
                            <button onClick={handleCommentSubmit} disabled={!newComment.trim()}>
                                Agregar Comentario
                            </button>
                        </div>
                    </div>

                    {/* Timeline */}
                    {reporte.statusHistory && reporte.statusHistory.length > 0 && (
                        <div className="detail-section">
                            <h3>Historial</h3>
                            <div className="detail-timeline">
                                {[...reporte.statusHistory].reverse().map((h, idx) => (
                                    <div key={idx} className="timeline-entry-admin">
                                        <div className="timeline-dot-admin" style={{
                                            background: STATUS_COLORS[h.toStatus] || '#95a5a6'
                                        }}></div>
                                        <div className="timeline-content-admin">
                                            <strong>{h.fromStatus ? `${h.fromStatus} -> ${h.toStatus}` : h.toStatus}</strong>
                                            {h.comment && <p>{h.comment}</p>}
                                            <span>
                                                {new Date(h.changedAt).toLocaleString('es-ES')}
                                                {h.changedBy?.username && ` - ${h.changedBy.username}`}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReporteDetailModal;
